export default __webpack_public_path__ + "static/HomepageScreenshot-df42c8307e4552427632d4d1871cd9ff.png";